import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  Root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  }
}));
